import { ProductUsageReportBaseEvent, ReportEventUnauthenticatedParams,TelemetryForwarder } from '@tableau/typescript-telemetry-forwarder';
import { DeprecatedEventWrapper } from '../../common/analyticsEvents/DeprecatedEventWrapper';
import { UserAgentSupport } from '../../common/utilities/UserAgentSupport';
import { Module } from '../Module';
import { ServerService } from './ServerService';
import { SessionService } from './SessionService';

/**
 * Deprecated because the design pattern was a mess, use TelemetryService instead of AnalyticsService.
 */
export class DeprecatedAnalyticsService {

  private eventType = 'vizportalclient';

  public static $inject = [
    'ServerService',
  ];

  private telemetryForwarder: TelemetryForwarder;

  constructor(private ServerService: ServerService) {
    // For some Online pods, ServerService.sessionServerId() doesn't contain the pod name. TFSID:594196
  }

  public EventFactory(_: string): DeprecatedEventWrapper {
    return new DeprecatedEventWrapper(
      this.sendEvent.bind(this),
      this.eventType,
      this.ServerService.sessionUserId(),
      this.ServerService.sessionSiteLuid(),
      'isMobileBrowser: ' + (UserAgentSupport.isMobileBrowser() ? 'yes' : 'no'));
  }

  public sendEvent(eventParams: ReportEventUnauthenticatedParams): void {
      if (!this.telemetryForwarder) {
        this.telemetryForwarder = this.getForwarder();
      }
      this.telemetryForwarder.send(eventParams);
  }

  private getForwarder() {
    return new TelemetryForwarder();
  }

}

Module.instance().service('DeprecatedAnalyticsService', DeprecatedAnalyticsService);
